// extracted by mini-css-extract-plugin
export default {"ChoiceCard":"📚19-10-2_HzRD","selected":"📚19-10-2PayF3","disabled":"📚19-10-2QPgUh"};